<div class="qa-tools">
  <div class="screen-loader" *ngIf="isMovingToProd">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="header-label">
    <h2>QA Tools</h2>
  </div>

  <div class="table-loader" *ngIf="isLoading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div [hidden]="isLoading" class="qa-content">
    <div *ngIf="errorMessage" class="error-message" role="alert" aria-live="polite"
      [matTooltip]="errorMessage">
      <span class="error-text one-line">{{ errorMessage }}</span>
    </div>

    <div *ngIf="successMessage" class="success-message" role="status" aria-live="polite">
      <span class="error-text">{{ successMessage }}</span>
    </div>

    <div class="run-nightly-job">
      <div class="run-nightly-job-title">Run Nightly Job:</div>

      <button mat-flat-button color="accent" (click)="runNightlyJob()" [disabled]="isMovingToProd">
        Start
      </button>
    </div>

    <div class="section-divider"></div>

    <div *ngIf="ftpList.length > 0">
      <div class="create-diaries-row">
        <div class="create-diaries-title">Create Diaries:</div>

        <mat-form-field appearance="outline" class="qa-autocomplete-field ftp-select">
          <input
            id="ftpSelect"
            matInput
            type="text"
            [formControl]="ftpControl"
            [matAutocomplete]="ftpAuto"
            #ftpTrigger="matAutocompleteTrigger"
            placeholder="-- Choose an FTP --"
            (input)="onFtpInputChange()"
          />
          <app-autocomplete-suffix-actions
            matSuffix
            [showClear]="ftpControl.value !== null && ftpControl.value !== ''"
            [preserveClearSlot]="true"
            [panelOpen]="ftpTrigger.panelOpen"
            (clearClicked)="clearSelectedFtp($event)"
            (toggleClicked)="openOrClosePanel($event, ftpTrigger)">
          </app-autocomplete-suffix-actions>
          <mat-autocomplete #ftpAuto="matAutocomplete"
                            [clearStaleSelectionOnOpen]="ftpControl.value"
                            [displayWith]="displayFtpText"
                            (optionSelected)="onFtpSelected($event.option.value)">
            <mat-option *ngFor="let ftp of filteredFtpOptions$ | async; trackBy: trackByStringFTP" [value]="ftp">
              {{ ftp.ftpDirectoryName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <input id="dateFrom" type="date" [(ngModel)]="selectedDate" [max]="maxDate" class="qa-input date-input" />

        <button mat-flat-button color="primary" (click)="startCreateDiaries()"
          [disabled]="isCreatingDiaries || !selectedFTP">
          {{ isCreatingDiaries ? 'Starting...' : 'Start' }}
        </button>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="qa-section beneficiary-management">
      <div class="section-title">Beneficiary Management</div>

      <div class="beneficiary-layout">
        <div class="beneficiary-grid">
          <div class="qa-grid-header">
            <div>Claim Key</div>
            <div>Claimant Key</div>
            <div>Insurance Type</div>
            <div>Medicare Eligibility Status</div>
            <div></div>
          </div>

          <div class="qa-grid-row" *ngFor="let row of gridRows; let i = index">
            <input type="text" class="qa-grid-input" [(ngModel)]="row.claimKey" placeholder="Enter text" />
            <input type="text" class="qa-grid-input" [(ngModel)]="row.claimantKey" placeholder="Enter text" />
            <input type="text" class="qa-grid-input" [(ngModel)]="row.insuranceType" placeholder="Enter text" />

            <mat-form-field appearance="outline" class="qa-inline-autocomplete-field">
              <input
                matInput
                [(ngModel)]="row.medicareEligibilityStatus"
                [matAutocomplete]="medicareStatusAuto"
                #medicareStatusTrigger="matAutocompleteTrigger"
                placeholder="-- Select --"
              />
              <app-autocomplete-suffix-actions
                matSuffix
                [showClear]="!!row.medicareEligibilityStatus"
                [panelOpen]="medicareStatusTrigger.panelOpen"
                (clearClicked)="clearBeneficiaryStatus($event, row)"
                (toggleClicked)="openOrClosePanel($event, medicareStatusTrigger)">
              </app-autocomplete-suffix-actions>
              <mat-autocomplete #medicareStatusAuto="matAutocomplete" [clearStaleSelectionOnOpen]="row.medicareEligibilityStatus">
                <mat-option *ngFor="let item of filterSimpleOptions(dropdownChoices, row.medicareEligibilityStatus)" [value]="item">{{ item }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <button mat-icon-button class="remove-row-btn" (click)="removeBeneficiaryRow(i)"
              [disabled]="gridRows.length === 1" aria-label="Remove row">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div class="mark-row-container">
            <button mat-flat-button color="primary" class="beneficiary-action-btn"
              [disabled]="isMarkingBeneficiaries || !hasAtLeastOneCompleteRow()" (click)="markBeneficiaries()">
              {{ isMarkingBeneficiaries ? 'Marking...' : 'Mark Beneficiaries' }}
            </button>
          </div>
        </div>

        <button mat-flat-button color="primary" class="beneficiary-add-btn"
          (click)="addBeneficiaryRow()" [disabled]="gridRows.length >= 5">
          Add Beneficiary
        </button>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="qa-section simulated-claim-submission-section">
      <div class="section-title">Simulated Claim Submission</div>

      <div class="simulated-claim-submission">
        <div class="select-rre-title">RRE:</div>

        <mat-form-field appearance="outline" class="qa-autocomplete-field rre-select">
          <input
            id="rreSelect"
            matInput
            type="text"
            [formControl]="rreControl"
            [matAutocomplete]="rreAuto"
            #rreTrigger="matAutocompleteTrigger"
            placeholder="-- Choose an RRE --"
            (input)="onRreInputChange()"
          />
          <app-autocomplete-suffix-actions
            matSuffix
            [showClear]="rreControl.value !== null && rreControl.value !== ''"
            [preserveClearSlot]="true"
            [panelOpen]="rreTrigger.panelOpen"
            (clearClicked)="clearSelectedRre($event)"
            (toggleClicked)="openOrClosePanel($event, rreTrigger)">
          </app-autocomplete-suffix-actions>
          <mat-autocomplete #rreAuto="matAutocomplete"
                            [clearStaleSelectionOnOpen]="rreControl.value"
                            [displayWith]="displayRreText"
                            (optionSelected)="onRreSelected($event.option.value)">
            <mat-option *ngFor="let rre of filteredRreOptions$ | async; trackBy: trackByStringRRE" [value]="rre">
              {{ rre.rre }} - {{ rre.rreName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <button mat-flat-button color="primary" (click)="simulateClaimSubmission()"
          [disabled]="!selectedRRE || !hasClaimUpdatesToSubmit() || isSubmittingClaims">
          Simulate Submission/Response
        </button>
      </div>

      <div class="claims-table-wrapper table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir" class="full-width">
          <ng-container matColumnDef="InjuredPartyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Injured Party Name</th>
            <td mat-cell *matCellDef="let claim">{{ claim.InjuredPartyName }}</td>
          </ng-container>

          <ng-container matColumnDef="ClaimNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Number</th>
            <td mat-cell *matCellDef="let claim">{{ claim.ClaimNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="InsuranceType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Insurance Type</th>
            <td mat-cell *matCellDef="let claim">{{ claim.InsuranceType }}</td>
          </ng-container>

          <ng-container matColumnDef="ClaimKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ICN/Claim Key</th>
            <td mat-cell *matCellDef="let claim">{{ claim.ClaimKey }}</td>
          </ng-container>

          <ng-container matColumnDef="DispositionCode">
            <th mat-header-cell *matHeaderCellDef>Disposition Code</th>
            <td mat-cell *matCellDef="let claim">
              <mat-form-field appearance="outline" class="qa-inline-autocomplete-field qa-claim-autocomplete-field">
                <input
                  matInput
                  [(ngModel)]="claim.DispositionCode"
                  [matAutocomplete]="dispositionCodeAuto"
                  #dispositionCodeTrigger="matAutocompleteTrigger"
                  placeholder="---Select---"
                  (ngModelChange)="onClaimDispositionCodeChange(claim)"
                />
                <app-autocomplete-suffix-actions
                  matSuffix
                  [showClear]="!!claim.DispositionCode"
                  [panelOpen]="dispositionCodeTrigger.panelOpen"
                  (clearClicked)="clearDispositionCode($event, claim)"
                  (toggleClicked)="openOrClosePanel($event, dispositionCodeTrigger)">
                </app-autocomplete-suffix-actions>
                <mat-autocomplete #dispositionCodeAuto="matAutocomplete" [clearStaleSelectionOnOpen]="claim.DispositionCode">
                  <mat-option *ngFor="let code of filterSimpleOptions(dispositionCodeOptions, claim.DispositionCode)" [value]="code">{{ code }}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="ErrorCode">
            <th mat-header-cell *matHeaderCellDef>Error Code (max 5 error codes)</th>
            <td mat-cell *matCellDef="let claim">
              <input type="text" [(ngModel)]="claim.ErrorCode" maxlength="30" class="qa-input"
                [disabled]="claim.DispositionCode !== 'SP'" />
            </td>
          </ng-container>

          <ng-container matColumnDef="Update">
            <th mat-header-cell *matHeaderCellDef>Update</th>
            <td mat-cell *matCellDef="let claim" class="actions-cell">
              <input type="checkbox" [(ngModel)]="claim.ShouldUpdate" [attr.aria-label]="'Update ' + claim.ClaimNumber" />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div *ngIf="claimDetailsList.length === 0" class="no-results-message">
          No claims found
        </div>
      </div>
      <mat-paginator
          showFirstLastButtons
          [length]="totalCount"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="claimsPageSizeOptions"
          (page)="onPageChange($event)"
          aria-label="Select claims table page"
        ></mat-paginator>
    </div>
  </div>
</div>